import React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const SubmitButton = ({
    className = '',
    buttonText = 'Submit',
    spinner = 'right',
    showSpinner = false,
    onClick,
    disabled = false,
    ...props
}) => {
    return (
        <Button
            onClick={onClick}
            disabled={disabled || showSpinner}
            className={cn('tw:w-[156px]', className)}
            {...props}
        >
            {spinner === 'left' && showSpinner && (
                <div className="tw:w-4 tw:h-4 tw:flex-shrink-0 tw:border-2 tw:border-white tw:border-t-transparent tw:rounded-full tw:animate-spin" />
            )}
            {showSpinner ? 'Loading...' : buttonText}
            {spinner === 'right' && showSpinner && (
                <div className="tw:w-4 tw:h-4 tw:flex-shrink-0 tw:border-2 tw:border-white tw:border-t-transparent tw:rounded-full tw:animate-spin" />
            )}
        </Button>
    )
}

export default SubmitButton
